import Keycloak from '../keycloak-js/keycloak'

export const defaultInitConfig: Keycloak.KeycloakInitOptions = {
  flow: 'standard',
  checkLoginIframe: false,
  onLoad: 'login-required',
}
